import env from '../env';

export default {
	RESET_PASSWORD: `${env.API_ACCOUNT}Account/ForgotPassword`,
	SIGNUP: `${env.API_ACCOUNT}Account/saveUserRequest`,
	SIGNIN: `${env.API_ACCOUNT}Account/Login`,
};
